module.exports = __webpack_public_path__ + "img/money.b2586ad4.png";